// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @use 'app/styles/vars/media' as media; */

.styles_MainContentBlock__NpC2O {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 80vh;
    padding-left: 10px;
    padding-right: 10px;
}

.styles_background__sP1mT {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    filter: blur(3px);

    >img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.styles_NewsBlock__FC\\+uj {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* // background: rgba(243, 247, 250, 1);
    // border-top: 1px dashed rgba(41, 127, 176, 0.51);
    // border-bottom: 1px dashed rgba(41, 127, 176, 0.51);

    @include media.media-sm {
        justify-content: flex-start;
        align-items: flex-start;
    } */

    h2 {
        display: none;

        /* @include media.media-sm {
            padding-left: 23px;
            margin-top: 32px;
            margin-bottom: 10px;
            display: block;
            text-align: left;
            color: #fff;

            font-family: Montserrat, serif;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        } */
    }
}
.styles_NewsHeader__9NvDc{
    /*background: #002b80;*/
    width: 75%;
    display: flex;
    justify-content: start;
    font-size: 22px;
    font-weight: 300;
}

.styles_MatchBeatsWrapper__v9Z9l{
    margin-top: 30px;
    max-width: 100%;
    overflow: hidden;
}

.styles_MatchBeats__iFLLc * {
    -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
}

.styles_MatchBeats__iFLLc {
    translate: 13px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    cursor: grab;
}

.styles_PlayersNamesBlock__wozw\\+{
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(222, 222, 222, 0.5);
}

.styles_OpponentName__bAxJx{
    display: flex;
    flex-direction: row;
    height: 62px;
}

.styles_OpponentName__bAxJx:first-child > .styles_OpponentNameLeftDivider__lUnkI{
    width: 9px;
    background: #469fee;
}

.styles_OpponentName__bAxJx:last-child > .styles_OpponentNameLeftDivider__lUnkI{
    width: 9px;
    background: #0f1745;
}

.styles_OpponentNameText__gBBFl {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    font-weight: 700;
}

.styles_OpponentDoubleName__LSBur{
    display: flex;
    flex-direction: row;
    height: 62px;
}

.styles_OpponentDoubleName__LSBur:nth-child(1) > .styles_OpponentNameLeftDivider__lUnkI{
    width: 9px;
    background: #469fee;
}
.styles_OpponentDoubleName__LSBur:nth-child(2) > .styles_OpponentNameLeftDivider__lUnkI{
    width: 9px;
    background: #469fee;
}
.styles_OpponentDoubleName__LSBur:nth-child(3) > .styles_OpponentNameLeftDivider__lUnkI{
    width: 9px;
    background: #0f1745;
}
.styles_OpponentDoubleName__LSBur:nth-child(4) > .styles_OpponentNameLeftDivider__lUnkI{
    width: 9px;
    background: #0f1745;
}

.styles_SetName__3BqKb {
    background: #282c34;
    color: #ffffff;
    width: 60px;
    height: 25px;
    font-weight: 500;
    padding-bottom: 2px;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 12px;
    transform: rotate(90deg);
    text-transform: uppercase;
}

.styles_GameResults__G4EUI {
    border: 1px solid #469fee;
    height: 154px;

    width: 86px;
    box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902);
    position: relative;
    padding: 3px;
}

.styles_DoubleGameResults__B6au4 {
    border: 1px solid #469fee;
    height: 170px;

    width: 86px;
    box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902);
    position: relative;
    padding: 3px;
}

.styles_Holds__Gh3T5 {
    height: 25%;
    font-weight: 700;
    text-align: center;
    font-size: 12px;
}

.styles_HoldsTeam__tCu91 {
    height: 12.5%;
    font-weight: 700;
    text-align: center;
    font-size: 12px;
}

.styles_GameScores__6YinU{
    display: flex;
    width: 100%;
    height: 50%;
    left: 35%;
    top: 35%;
    justify-content: center;
    align-items: center;
}
.styles_GameScoreBar__qgwAP{
    display: grid;
    height: 50%;
    grid-template-columns: 1fr 2fr;
}

.styles_GameResultScore__PtIeZ{
    display: flex;
    justify-content: start;
    align-items: start;
}

.styles_GameTime__JcetL{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    border-top: 1px solid rgba(200, 200, 200, 0.3);
    border-bottom: 1px solid rgba(200, 200, 200, 0.3);
    font-size: 12px;
    font-weight: 700;
}
.styles_TimeImage__3yc3m{
    width: 15px;
    height: 15px;
    stroke: rgba(200, 200, 200);
    margin: 3px;
}
.styles_VideoFrame__kLuFY{
    /*background: #B0282D;*/
    width: 100%;
    /*height: max-content;*/
    height: 37vw;
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
@media screen and (max-width: 780px){
    .styles_VideoFrame__kLuFY{
        height: 70vw;
        /*height: max-content;*/


    }
}
.styles_VideoFrame__kLuFY * {
    width: 96%;
}

.styles_Insights__ZRfSN {
    margin-top: 20px;
    margin-left: 30px;
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
}
@media screen and (max-width: 1025px){
    .styles_Insights__ZRfSN {
        height: max-content;
        margin-left: 0;
        justify-content: center;
    }
}
.styles_InsightSetName__ulrpC {
    /*align-items: center;*/
    /*height: 100%;*/
    background: #334C5B;
    color: #fff;
    padding: 8px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    margin-left: 10px;
}
.styles_SetInsight__CqIB8{
    border: 1px solid rgba(200, 200, 200, 0.3);
    padding: 8px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    margin-right: 10px;
}
.styles_UserSchema__r6SwJ {
    /*background: #B0282D;*/
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 50px;
    justify-content: end;
    align-items: center;
    gap: 30px;
    padding: 0 10px;
}

@media screen and (max-width: 450px) {
    .styles_UserSchema__r6SwJ {
        justify-content: space-between;
        gap: 0;
    }
    .styles_Sign__66dhP span{
        width: min-content;
    }
}
.styles_Sign__66dhP{
    align-items: center;
    display: flex;
    width: max-content;
    /*width: 150px;*/
}
.styles_Sign__66dhP:nth-child(2) > img{
    display: flex;
    margin-top: 4px;
    margin-left: 5px;
}

.styles_Sign__66dhP:nth-child(1) > img{
    display: flex;
    margin-top: 4px;
    margin-left: 5px;
}

.styles_Sign__66dhP:nth-child(3) > img{
    display: flex;
    /*margin-top: 5px;*/
    margin-left: 5px;
}
.styles_ResultScore__kxx\\+x{
    width: 21px;
    height: 21px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    border: 1px solid #469fee;
    border-radius: 8px;
}

.styles_TieTop__wc9P7, .styles_TieBottom__tLWZb {
    position: absolute;
    font-size: 12px;
    background-color: #469fee;
    color: #fff;
    padding: 1px 5px;
    border-radius: 10px;
}

.styles_TieTop__wc9P7{
    top: 50px;
    right: 16px;
}

.styles_TieBottom__tLWZb{
    bottom:45px;
    right: 16px;
}


@media screen and (max-width: 450px) {
    .styles_Sign__66dhP span{
        width: min-content;
    }
}
.styles_Sign__66dhP{
    align-items: center;
    display: flex;
    width: max-content;
    /*width: 150px;*/
}
.styles_Sign__66dhP:nth-child(2) > img{
    display: flex;
    margin-top: 4px;
    margin-left: 5px;
}

.styles_Sign__66dhP:nth-child(1) > img{
    display: flex;
    margin-top: 4px;
    margin-left: 5px;
}

.styles_Sign__66dhP:nth-child(3) > img{
    display: flex;
    /*margin-top: 5px;*/
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/match-editor/ui/MatchBeatsWidget/styles.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,WAAW;IACX,iBAAiB;;IAEjB;QACI,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB;;;;;;;OAOG;;IAEH;QACI,aAAa;;QAEb;;;;;;;;;;;;;WAaG;IACP;AACJ;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,WAAW,EACf,oBAAoB;IAC3C,iBAAiB,EAAE,oBAAoB;AAC3C;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;;IAEb,WAAW;IACX,mDAAmD;IACnD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;;IAEb,WAAW;IACX,mDAAmD;IACnD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;IAC9C,iDAAiD;IACjD,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI;QACI,YAAY;QACZ,uBAAuB;;;IAG3B;AACJ;AACA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI;QACI,mBAAmB;QACnB,cAAc;QACd,uBAAuB;IAC3B;AACJ;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,0CAA0C;IAC1C,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,8BAA8B;QAC9B,MAAM;IACV;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;;AAGA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":["/* @use 'app/styles/vars/media' as media; */\n\n.MainContentBlock {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 80vh;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: -1;\n    filter: blur(3px);\n\n    >img {\n        object-fit: cover;\n        width: 100%;\n        height: 100%;\n    }\n}\n\n.NewsBlock {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    /* // background: rgba(243, 247, 250, 1);\n    // border-top: 1px dashed rgba(41, 127, 176, 0.51);\n    // border-bottom: 1px dashed rgba(41, 127, 176, 0.51);\n\n    @include media.media-sm {\n        justify-content: flex-start;\n        align-items: flex-start;\n    } */\n\n    h2 {\n        display: none;\n\n        /* @include media.media-sm {\n            padding-left: 23px;\n            margin-top: 32px;\n            margin-bottom: 10px;\n            display: block;\n            text-align: left;\n            color: #fff;\n\n            font-family: Montserrat, serif;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n        } */\n    }\n}\n.NewsHeader{\n    /*background: #002b80;*/\n    width: 75%;\n    display: flex;\n    justify-content: start;\n    font-size: 22px;\n    font-weight: 300;\n}\n\n.MatchBeatsWrapper{\n    margin-top: 30px;\n    max-width: 100%;\n    overflow: hidden;\n}\n\n.MatchBeats * {\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none; /* Standard syntax */\n}\n\n.MatchBeats {\n    translate: 13px 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: fit-content;\n    cursor: grab;\n}\n\n.PlayersNamesBlock{\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid rgba(222, 222, 222, 0.5);\n}\n\n.OpponentName{\n    display: flex;\n    flex-direction: row;\n    height: 62px;\n}\n\n.OpponentName:first-child > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #469fee;\n}\n\n.OpponentName:last-child > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #0f1745;\n}\n\n.OpponentNameText {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 150px;\n    font-weight: 700;\n}\n\n.OpponentDoubleName{\n    display: flex;\n    flex-direction: row;\n    height: 62px;\n}\n\n.OpponentDoubleName:nth-child(1) > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #469fee;\n}\n.OpponentDoubleName:nth-child(2) > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #469fee;\n}\n.OpponentDoubleName:nth-child(3) > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #0f1745;\n}\n.OpponentDoubleName:nth-child(4) > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #0f1745;\n}\n\n.SetName {\n    background: #282c34;\n    color: #ffffff;\n    width: 60px;\n    height: 25px;\n    font-weight: 500;\n    padding-bottom: 2px;\n    text-align: center;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    border-radius: 12px;\n    transform: rotate(90deg);\n    text-transform: uppercase;\n}\n\n.GameResults {\n    border: 1px solid #469fee;\n    height: 154px;\n\n    width: 86px;\n    box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902);\n    position: relative;\n    padding: 3px;\n}\n\n.DoubleGameResults {\n    border: 1px solid #469fee;\n    height: 170px;\n\n    width: 86px;\n    box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902);\n    position: relative;\n    padding: 3px;\n}\n\n.Holds {\n    height: 25%;\n    font-weight: 700;\n    text-align: center;\n    font-size: 12px;\n}\n\n.HoldsTeam {\n    height: 12.5%;\n    font-weight: 700;\n    text-align: center;\n    font-size: 12px;\n}\n\n.GameScores{\n    display: flex;\n    width: 100%;\n    height: 50%;\n    left: 35%;\n    top: 35%;\n    justify-content: center;\n    align-items: center;\n}\n.GameScoreBar{\n    display: grid;\n    height: 50%;\n    grid-template-columns: 1fr 2fr;\n}\n\n.GameResultScore{\n    display: flex;\n    justify-content: start;\n    align-items: start;\n}\n\n.GameTime{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    border-top: 1px solid rgba(200, 200, 200, 0.3);\n    border-bottom: 1px solid rgba(200, 200, 200, 0.3);\n    font-size: 12px;\n    font-weight: 700;\n}\n.TimeImage{\n    width: 15px;\n    height: 15px;\n    stroke: rgba(200, 200, 200);\n    margin: 3px;\n}\n.VideoFrame{\n    /*background: #B0282D;*/\n    width: 100%;\n    /*height: max-content;*/\n    height: 37vw;\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n}\n@media screen and (max-width: 780px){\n    .VideoFrame{\n        height: 70vw;\n        /*height: max-content;*/\n\n\n    }\n}\n.VideoFrame * {\n    width: 96%;\n}\n\n.Insights {\n    margin-top: 20px;\n    margin-left: 30px;\n    display: flex;\n    flex-direction: row;\n    text-transform: uppercase;\n}\n@media screen and (max-width: 1025px){\n    .Insights {\n        height: max-content;\n        margin-left: 0;\n        justify-content: center;\n    }\n}\n.InsightSetName {\n    /*align-items: center;*/\n    /*height: 100%;*/\n    background: #334C5B;\n    color: #fff;\n    padding: 8px;\n    border-top-left-radius: 8px;\n    border-bottom-left-radius: 8px;\n    margin-left: 10px;\n}\n.SetInsight{\n    border: 1px solid rgba(200, 200, 200, 0.3);\n    padding: 8px;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n    margin-right: 10px;\n}\n.UserSchema {\n    /*background: #B0282D;*/\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 50px;\n    justify-content: end;\n    align-items: center;\n    gap: 30px;\n    padding: 0 10px;\n}\n\n@media screen and (max-width: 450px) {\n    .UserSchema {\n        justify-content: space-between;\n        gap: 0;\n    }\n    .Sign span{\n        width: min-content;\n    }\n}\n.Sign{\n    align-items: center;\n    display: flex;\n    width: max-content;\n    /*width: 150px;*/\n}\n.Sign:nth-child(2) > img{\n    display: flex;\n    margin-top: 4px;\n    margin-left: 5px;\n}\n\n.Sign:nth-child(1) > img{\n    display: flex;\n    margin-top: 4px;\n    margin-left: 5px;\n}\n\n.Sign:nth-child(3) > img{\n    display: flex;\n    /*margin-top: 5px;*/\n    margin-left: 5px;\n}\n.ResultScore{\n    width: 21px;\n    height: 21px;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #469fee;\n    border-radius: 8px;\n}\n\n.TieTop, .TieBottom {\n    position: absolute;\n    font-size: 12px;\n    background-color: #469fee;\n    color: #fff;\n    padding: 1px 5px;\n    border-radius: 10px;\n}\n\n.TieTop{\n    top: 50px;\n    right: 16px;\n}\n\n.TieBottom{\n    bottom:45px;\n    right: 16px;\n}\n\n\n@media screen and (max-width: 450px) {\n    .Sign span{\n        width: min-content;\n    }\n}\n.Sign{\n    align-items: center;\n    display: flex;\n    width: max-content;\n    /*width: 150px;*/\n}\n.Sign:nth-child(2) > img{\n    display: flex;\n    margin-top: 4px;\n    margin-left: 5px;\n}\n\n.Sign:nth-child(1) > img{\n    display: flex;\n    margin-top: 4px;\n    margin-left: 5px;\n}\n\n.Sign:nth-child(3) > img{\n    display: flex;\n    /*margin-top: 5px;*/\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContentBlock": `styles_MainContentBlock__NpC2O`,
	"background": `styles_background__sP1mT`,
	"NewsBlock": `styles_NewsBlock__FC+uj`,
	"NewsHeader": `styles_NewsHeader__9NvDc`,
	"MatchBeatsWrapper": `styles_MatchBeatsWrapper__v9Z9l`,
	"MatchBeats": `styles_MatchBeats__iFLLc`,
	"PlayersNamesBlock": `styles_PlayersNamesBlock__wozw+`,
	"OpponentName": `styles_OpponentName__bAxJx`,
	"OpponentNameLeftDivider": `styles_OpponentNameLeftDivider__lUnkI`,
	"OpponentNameText": `styles_OpponentNameText__gBBFl`,
	"OpponentDoubleName": `styles_OpponentDoubleName__LSBur`,
	"SetName": `styles_SetName__3BqKb`,
	"GameResults": `styles_GameResults__G4EUI`,
	"DoubleGameResults": `styles_DoubleGameResults__B6au4`,
	"Holds": `styles_Holds__Gh3T5`,
	"HoldsTeam": `styles_HoldsTeam__tCu91`,
	"GameScores": `styles_GameScores__6YinU`,
	"GameScoreBar": `styles_GameScoreBar__qgwAP`,
	"GameResultScore": `styles_GameResultScore__PtIeZ`,
	"GameTime": `styles_GameTime__JcetL`,
	"TimeImage": `styles_TimeImage__3yc3m`,
	"VideoFrame": `styles_VideoFrame__kLuFY`,
	"Insights": `styles_Insights__ZRfSN`,
	"InsightSetName": `styles_InsightSetName__ulrpC`,
	"SetInsight": `styles_SetInsight__CqIB8`,
	"UserSchema": `styles_UserSchema__r6SwJ`,
	"Sign": `styles_Sign__66dhP`,
	"ResultScore": `styles_ResultScore__kxx+x`,
	"TieTop": `styles_TieTop__wc9P7`,
	"TieBottom": `styles_TieBottom__tLWZb`
};
export default ___CSS_LOADER_EXPORT___;
